import { Component, input, Input, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlaAdherenceResponse, QueryType } from 'src/app/core/services/analytics.service';
import { SlaAdherenceDetailsService } from './services/slaadherencedetails.service';
import { environment } from 'src//environments/environment';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { GridModule, ExcelModule, GridDataResult } from '@progress/kendo-angular-grid';
import { SkeletonModule } from '@progress/kendo-angular-indicators';
import { Observable } from 'rxjs';
import { DATE_FILTER_OPERATORS } from 'src/app/core/constants/filter-operators';

@Component({
  selector: 'app-sla-adherence-card',
  standalone: true,
  imports: [CommonModule, DialogsModule, GridModule, ExcelModule, SkeletonModule],
  templateUrl: './sla-adherence-card.component.html',
  styleUrl: './sla-adherence-card.component.scss',
  providers: [SlaAdherenceDetailsService],
})
export class SlaAdherenceCardComponent {
  // New signal input for the API response
  slaAdherenceV2 = input<SlaAdherenceResponse>(new SlaAdherenceResponse());

  // Keep old inputs for backward compatibility
  @Input() slaAdherence: number = 0;
  @Input() previousSlaAdherence: number = 0;

  public readonly gridService = inject(SlaAdherenceDetailsService);
  public showPopup = false;
  public organizationId = input<number | null>();
  public filteredOrgIds = input<number[]>([]); // For query parameters
  public startDate = input<string | null>();
  public endDate = input<string | null>();
  public dateFilterOperators = DATE_FILTER_OPERATORS;
  queryType = input<QueryType>(QueryType.All);
  selectedOrgIds = input<number[]>([]);

  public Math = Math;

  // Computed signal to determine if data is loading
  public isLoading = computed(() => {
    const data = this.slaAdherenceV2();
    // Data is considered loading if all critical properties are null/undefined or 0
    return (
      !data ||
      (data.sla_adherence_pct_current === null && data.sla_adherence_pct_previous === null) ||
      (data.sla_adherence_pct_current === 0 &&
        data.sla_adherence_pct_previous === 0 &&
        data.sla_violation_count_current === 0 &&
        data.sla_violation_count_previous === 0)
    );
  });

  onContextMenuSelect(event: any) {
    if (event?.text === 'View Data') {
      // Determine query type and org IDs based on filter context
      const queryType = this.queryType().toLowerCase(); // 'all' or 'filtered'
      const orgIds =
        this.queryType() === QueryType.Filtered && this.selectedOrgIds().length > 0
          ? this.selectedOrgIds().join(',')
          : this.organizationId();

      const baseQueryString = `org_ids=${orgIds}&type=${queryType}`;
      const queryString = `${baseQueryString}&current_start=${this.startDate()}&current_end=${this.endDate()}`;

      this.gridService.url = `${environment.apiUrl}/v1/analytics/administrative/slaadherencemetricsdetails(${this.organizationId()})`;
      this.gridService.appendQueryString = queryString;
      this.gridService.read();
      this.showPopup = true;
    } else {
      console.warn('Invalid event structure:', event);
    }
  }

  public allData = (): Observable<GridDataResult> => {
    return this.gridService.queryAll();
  };

  // Close popup
  close() {
    this.showPopup = false;
  }
}
